/*
各種ソーシャルサービスボタンを簡単設置

2016/11/24 ver.2.0.0
	- Webpack対応
*/


exports.set_share_button = function( target ){
	'use strict';

	var window_opt = "width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1";
	var e = encodeURIComponent;

	// クリック動作
	$(document).on('click', target, function(){
		var $this = $(this);
		var url = $this.data('ccl-share-url');
		var msg = $this.data('ccl-share-msg');
		var via = $this.data('ccl-share-via');
		var flw = $this.data('ccl-share-flw');

		if( !url ) url = location.href;
		if( !msg ) msg = document.title;

		switch( $this.data('ccl-share-svc') ){
			case 'twitter':
				twitter(url, msg, via, flw); break;
			case 'facebook':
				facebook(url); break;
			case 'line':
				line(url, msg); break;
			case 'feedly':
				feedly(url); break;
			case 'pocket':
				pocket(url); break;
			case 'hatebu':
				hatebu(url, msg); break;
			case 'google':
				google(url); break;
		}

		return false;
	});

	/***************************
	* Twitter
	*/
	function twitter( url, msg, via, follow ){
	    'use strict';
		var openURL = 'http://twitter.com/share?url=' + e(url) + '&text=' + e(msg) + '+';
		if( via ) openURL += '&via=' + e(via);
		if( follow ) openURL += '&related=' + e(follow);
		window.open( openURL, 'tweetwindow', window_opt );
		return false;
	}

	/***************************
	* Facebook
	*/
	function facebook( url ){
	    'use strict';
		var openURL = 'http://www.facebook.com/share.php?u='+ e(url);
		window.open( openURL, 'facebookwindow', window_opt );
		return false;
	}

	/***************************
	* LINE
	*/
	function line( url, msg ){
	    'use strict';
		window.location.href = 'line://msg/text/' + e(msg) + ' ' + e(url);
		return false;
	}

	/***************************
	* feedly
	*/
	function feedly( url ){
	    'use strict';
		var openURL = 'http://feedly.com/i/subscription/feed/' + e(url);
		window.open( openURL, 'feedlywindow', window_opt );
		return false;
	}

	/***************************
	* Pocket
	*/
	function pocket( url ){
	    'use strict';
		var openURL = 'http://getpocket.com/edit?url=' + e(url);
		window.open( openURL, 'feedlywindow', window_opt );
		return false;
	}

	/***************************
	* はてなブックマーク
    <li class="hatebu"><a expr:href='"http://b.hatena.ne.jp/add?mode=confirm&amp;url=" + data:post.canonicalUrl + "&amp;" + data:post.title + "｜" + data:blog.title' target="_blank" onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"><i class="fa">B!</i><br/>はてブ</a></li>

http://b.hatena.ne.jp/add?mode=confirm&amp;url=http%3A%2F%2Fgo-taiwan.localhost%3A8080%2Fsanxia%2F&amp;%E5%8F%B0%E6%B9%BE%E3%81%AE%E3%83%9E%E3%82%A4%E3%83%8A%E3%83%BC%E8%A6%B3%E5%85%89%E5%90%8D%E6%89%80%E3%83%BB%E4%B8%89%E5%B3%BD%E3%81%AE%E8%A6%8B%E6%89%80%E3%81%A8%E3%82%B0%E3%83%AB%E3%83%A1%E3%82%92%E7%B4%B9%E4%BB%8B%EF%BC%81%20%20%7C%20%20%E3%81%A1%E3%82%87%E3%81%A3%E3%81%A8%E5%8F%B0%E6%B9%BE%E3%81%84%E3%81%A3%E3%81%A6%E3%81%8D%E3%81%BE%E3%81%99%E2%88%92%E5%8F%B0%E6%B9%BE%E6%97%85%E8%A1%8C%E3%83%96%E3%83%AD%E3%82%B0%E2%88%92

http://b.hatena.ne.jp/add?mode=confirm&url=http%3A%2F%2Fgo-taiwan.localhost%3A8080%2Fsanxia%2F&%E5%8F%B0%E6%B9%BE%E3%81%AE%E3%83%9E%E3%82%A4%E3%83%8A%E3%83%BC%E8%A6%B3%E5%85%89%E5%90%8D%E6%89%80%E3%83%BB%E4%B8%89%E5%B3%BD%E3%81%AE%E8%A6%8B%E6%89%80%E3%81%A8%E3%82%B0%E3%83%AB%E3%83%A1%E3%82%92%E7%B4%B9%E4%BB%8B%EF%BC%81%20%20%7C%20%20%E3%81%A1%E3%82%87%E3%81%A3%E3%81%A8%E5%8F%B0%E6%B9%BE%E3%81%84%E3%81%A3%E3%81%A6%E3%81%8D%E3%81%BE%E3%81%99%E2%88%92%E5%8F%B0%E6%B9%BE%E6%97%85%E8%A1%8C%E3%83%96%E3%83%AD%E3%82%B0%E2%88%92
		var openURL = 'http://twitter.com/share?url=' + e(url) + '&text=' + e(msg) + '+';

	*/
	function hatebu( url, msg ){
	    'use strict';
		var openURL = '//b.hatena.ne.jp/add?mode=confirm&url=' + e(url) + "&title=" + e(msg);
		// var openURL = '//b.hatena.ne.jp/entry/' + e(url);
		window.open( openURL, 'hatebuwindow', window_opt );
		return false;
	}

	/***************************
	* google plus
	*/
	function google( url ){
	    'use strict';
		var openURL = 'https://plus.google.com/share?url=' + e(url);
		window.open( openURL, 'googlewindow', window_opt );
		return false;
	}

};


/*****************
 ** WEBPACK FOOTER
 ** /Users/dada/www/_template/.src/js/caracol2.0.0/social/share_button.js
 ** module id = 7
 ** module chunks = 0
 **/